/**
 *
 */


import React, {createRef, RefObject} from 'react';
import { $window } from '@umu/umu-dom';
import { components } from 'common';
const { PreImg } = components;

import './headerBannerMask.scss';

interface IProps {
    headerImg: string;
}

interface IState {
    coverHeigth: number;
}

export default class HeaderBannerMask extends React.Component<IProps, IState> {
    public headerBannerRef: RefObject <HTMLDivElement>;
    public state: IState;

    constructor(props: IProps) {
        super(props);

        this.state = {
            coverHeigth: 0,
        };

        this.headerBannerRef = createRef();

    }

    public componentDidMount() {
        this.calcCoverHeight();
        this.bindEvents();
    }

    public componentWillUnmount() {
        $window.removeEventListener('load', this.calcCoverHeight);
        $window.removeEventListener('resize', this.calcCoverHeight);
    }

    public bindEvents = () => {
        $window.addEventListener('load', this.calcCoverHeight);
        $window.addEventListener('resize', this.calcCoverHeight);
    }

    public calcCoverHeight = () => {
        const classCard = this.headerBannerRef;
        if (classCard.current) {
            const coverWidth = classCard.current.offsetWidth;
            const coverHeigth = Math.ceil(coverWidth * (9 / 16));
            this.setState({coverHeigth});
        }
    }

    public render() {
        return (
            <div className="header-banner" ref={this.headerBannerRef}>
                <div className="placeholder"></div>
                <div className="header-content">
                    {this.props.children}
                </div>
                <PreImg><img
                    style={{
                    height: `${this.state.coverHeigth}px`,
                }}
                    src={this.props.headerImg}
                    alt=""/></PreImg>
            </div>
        );
    }

}
